/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable eqeqeq */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import GenderFilter from '../../../../../pages/SearchPage/Filters/GenderFilter';
import UtrFilter from '../../../../../pages/SearchPage/Filters/UtrFilter';
import UtrpFilter from '../../../../../pages/SearchPage/Filters/UtrpFilter';
import EventDateFilter from '../../../../../pages/SearchPage/Filters/EventDateFilter';
import EventAgeRangeFilter from '../../../../../pages/SearchPage/Filters/EventAgeRangeFilter';
import LeagueTypeFilter from '../../../../../pages/SearchPage/Filters/LeagueTypeFilter';

import { ageSliderDictionary } from '../../../../../utils/constants';
import { sportTypeIds } from '../../../../../utils/eventConstants';
import { EventTypes } from '../../../../../utils/clubs';

import styles from '../../../../../pages/ClubProfiles/club.scss';
import searchStyles from '../../../../../pages/SearchPage/search.scss';

const LeaguesFilters = ({ filters, setFilters, defaultFilterValues, sportTypeId }) => {
    const [filterInputs, setFilterInputs] = useState(defaultFilterValues);
    const [filterModal, setFilterModal] = useState('');
    const wrapperRef = useRef(null);
    const auth = useSelector(({ auth }) => auth);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    const handleFilterClick = (type) => {
        setFilterModal(filterModal === type ? '' : type);
    };

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            if (!e.target.classList.contains('menu-item')) { // menu item click not working when the bottom code is called, hackish way to avoid calling if menu item clicked
                undoFilterChange();
                setFilterModal('');
            }
        }
    };

    function undoFilterChange() {
        // reset (unapplied) filter changes
        setFilterInputs(filters);
    }

    // Gender filter modal
    const handleGenderClick = ({ gender }) => {
        setFilters({
            ...filters,
            gender,
        });
        setFilterInputs({
            ...filterInputs,
            gender,
        });
        setFilterModal('');
    };

    const handleLeagueTypeClick = ({ type }) => {
        setFilters({
            ...filters,
            LeagueSessionType: type,
        });
        setFilterInputs({
            ...filterInputs,
            LeagueSessionType: type,
        });
        setFilterModal('');
    };

    const handleFilterSubmit = () => {
        setFilters(filterInputs);
        setFilterModal('');
    };

    const handleFilterUpdate = (props, update) => {
        // only updates filter input field values, input field values have no effect on filter state, these changes don't get submitted, users have to click the apply button first
        // Filter input state is stored in 'filterInputs'
        if (!update || update === 'filterInput') {
            setFilterInputs({
                ...filterInputs,
                ...props,
            });
        }
    };

    const clearFilters = () => {
        setFilters(defaultFilterValues);
        setFilterInputs(defaultFilterValues);
        setFilterModal('');
    };

    const closeModals = () => {
        setFilterModal('');
    };

    const hasDataChanged = JSON.stringify(filters) !== JSON.stringify(defaultFilterValues);

    const eventsAgeDisplay = (ageMin, ageMax) => {
        ageMin = ageMin || 0;
        ageMax = ageMax || 23;
        if (ageMin == 0 && ageMax == Object.keys(ageSliderDictionary).length - 1) {
            return 'All';
        }
        if (ageMin == ageMax && ageMin == 0) {
            return `${ageSliderDictionary[1]} and Under`;
        }
        if (ageMin == ageMax && ageMax == Object.keys(ageSliderDictionary).length - 1) {
            return `${ageSliderDictionary[ageMax - 1]} and Over`;
        }
        if (ageMin === ageMax) {
            return `Age ${ageSliderDictionary[ageMin]} Only`;
        }
        if (ageMin == 0) {
            return `${ageSliderDictionary[ageMax]} and Under`;
        }
        if (ageMax == Object.keys(ageSliderDictionary).length - 1) {
            return `${ageSliderDictionary[ageMin]} and Over`;
        }
        return `${ageSliderDictionary[ageMin]} to ${ageSliderDictionary[ageMax]}`;
    };

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal,
        closeModals,
        handleFilterSubmit,
        handleFilterUpdate,
        type: EventTypes.LEAGUES,
    };

    const dateSelectOptions = [
        { value: 'allFuture', label: 'Upcoming Events' },
        { value: 'allInProgress', label: 'In Progress Events' },
        { value: 'allPast', label: 'Past Events' },
        { value: 'custom', label: 'Custom Date Range' },
    ];

    return (
        <div>
            <div className={`${styles.titleContainer} ${styles.filterContainer} row bt bb mt0 pt16 mb16 pb8`} ref={wrapperRef}>
                <div className={`col-12 col-md-8`}>
                    <div className={`${searchStyles.searchFilters} np nb`}>
                        <EventDateFilter
                            {...commonFilterProps}
                            customDateSelectOptions={dateSelectOptions}
                            data-testid="club-leagues.filter.date"
                        />
                        {sportTypeId === sportTypeIds.PICKLEBALL ? (
                            <UtrpFilter {...commonFilterProps} data-testid="club-leagues.filter.utrp" />
                        ) : (
                            <UtrFilter
                                {...commonFilterProps}
                                isLeaguesTab={true}
                                isHalfSteps={true}
                                showExpandedUtrFilter={false}
                                isMemberFilter={true}
                                data-testid="club-leagues.filter.utr"
                            />
                        )}
                        <EventAgeRangeFilter
                            {...commonFilterProps}
                            userLoggedIn={!!auth.user}
                            ageDisplay={eventsAgeDisplay}
                            data-testid="club-leagues.filter.age-range"
                        />
                        <GenderFilter
                            {...commonFilterProps}
                            handleFilterUpdate={handleGenderClick}
                            data-testid="club-leagues.filter.gender"
                        />
                        <LeagueTypeFilter
                            {...commonFilterProps}
                            handleFilterUpdate={handleLeagueTypeClick}
                            data-testid="club-leagues.filter.league-type"
                        />
                        {hasDataChanged && <u className="clickable text-teal text-small text-normal no-wrap" onClick={clearFilters}>reset filters</u>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeaguesFilters;
